<script setup lang="ts" generic="T extends string">
import { reactive } from "vue";
import { context } from "../../context/context";
import BooleanBox, { type BooleanBoxModePattern } from "./BooleanBox.vue";
import { ColorPattern } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { BooleanBox }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    disabledIndexs?: Array<number>;
    initIndexs?: Array<number>;

    mode?: BooleanBoxModePattern;
    colorPattern?: ColorPattern;

    itemPadding?: string;
    labelPadding?: string;
  }>(),
  {
    mode: "primary-round",
    colorPattern: context.store.getState().color
      .colorPattern as unknown as ColorPattern,

    itemPadding: "10px",
    labelPadding: "2px"
  }
);

const emits = defineEmits<{
  (event: "change", values: T[]): void;
}>();

const selectedIndexes = reactive(props.initIndexs ?? []);

const change = (index: number, selected: boolean) => {
  const findIndex = selectedIndexes.findIndex((i) => i === index);
  let isChange = false;
  if (findIndex >= 0 && !selected) {
    selectedIndexes.splice(findIndex, 1);
    isChange = true;
  } else if (findIndex < 0 && selected) {
    selectedIndexes.push(index);
    isChange = true;
  }
  if (isChange) {
    emits(
      "change",
      selectedIndexes.map((index) => props.options[index])
    );
  }
};
</script>

<template>
  <div
    class="checkbox-group"
    v-for="(option, index) in options"
    :key="index"
    :style="['margin-left:' + (index > 0 ? props.itemPadding : 0)]"
  >
    <BooleanBox
      :mode="props.mode"
      :colorPattern="props.colorPattern"
      :selected="selectedIndexes.findIndex((i) => i === index) >= 0"
      :disabled="
        disabledIndexs && disabledIndexs.findIndex((i) => i === index) >= 0
      "
      @change="(v) => change(index, v)"
    ></BooleanBox>
    <span
      v-if="option"
      :style="['font-size:1em', 'margin-left:' + props.labelPadding]"
    >
      {{ option }}
    </span>
  </div>
</template>

<style scoped>
.checkbox-group {
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
